module.exports = __webpack_public_path__ + "img/icwithdraw.b3ce18fc.png";